import { render, staticRenderFns } from "./SuperAdminLiveCourse.vue?vue&type=template&id=4af8e8da&scoped=true"
import script from "./SuperAdminLiveCourse.vue?vue&type=script&lang=js"
export * from "./SuperAdminLiveCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8e8da",
  null
  
)

export default component.exports